// helper functions for type conversion

import { ShopCore } from "@/abilities/shop/types/shop-core";
import { getCurrencySymbol } from "./get-currency-symbol";

/**
 * Maps numeric stock status to StockStatus enum
 * - 0: IN_STOCK (available)
 * - 1: LOW_STOCK (low-stock)
 * - -1: UNAVAILABLE (shop offline or unavailable)
 * - other: OUT_OF_STOCK
 */
function mapNumericStockStatus(stockStatus: number): ShopCore.StockStatus {
    switch (stockStatus) {
        case 0:
            return ShopCore.StockStatus.AVAILABLE;
        case 1:
            return ShopCore.StockStatus.LOW_STOCK;
        case -1:
            return ShopCore.StockStatus.UNAVAILABLE;
        default:
            return ShopCore.StockStatus.OUT_OF_STOCK;
    }
}

export function getWidgetItemFromInfoItem(item: ShopCore.ItemInfo): ShopCore.WidgetItem {
    return {
        price: {
            amount: item.price,
            currency: item.currencySign !== "" ? item.currencySign : undefined,
            currencySign: item.currencySign !== "" ? getCurrencySymbol(item.currencySign) : undefined,
            onRequestOnly: item.showPriceOnRequest,
        },
        stock: {
            available: mapNumericStockStatus(item.stockStatus),
            quantity: item.amountAvailable,
        },
    };
}
